import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../../utilities/auth-context';

// MUI Components
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';

const pluginDownloadUrl = `${process.env.REACT_APP_API_ENDPOINT}/download-plugin`;

const Header = ({ isAuthenticated }) => {

    const { dispatch } = useContext(AuthContext);

    const navLinks = [
        { label: 'Dashboard', to: '/' },
        { label: 'Settings', to: '/settings' },
    ];

    const logout = () => {
        dispatch({ type: 'LOGOUT' });
    }

    return (
        <Box className='site-header'>
            <Container maxWidth="xl" className='header-container'>
                <img src={`${process.env.REACT_APP_BASE_URL}/media/simplistics-logo.png`} alt='Simple Monitor' />
                {isAuthenticated && (
                    <Box className='header-links'>
                        {navLinks.map((link) => (
                            <Link
                                key={link.to}
                                component={NavLink}
                                to={link.to}
                                end={link.to === '/'}
                                underline="hover"
                                variant="body2"
                                color="inherit"
                                sx={{
                                    '&.active': {
                                        color: 'primary.main',
                                        textDecoration: 'underline',
                                    },
                                }}
                            >
                                {link.label}
                            </Link>
                        ))}
                        <Link
                            href="#"
                            onClick={() => logout()}
                            underline="hover"
                            variant="body2"
                            color="inherit"
                        >
                            Logout
                        </Link>
                        <Button
                            variant='contained'
                            color='primary'
                            size='small'
                            component='a'
                            href={pluginDownloadUrl}
                        >
                            Download Plugin
                        </Button>
                    </Box>
                )}
            </Container>
        </Box>
    );
};

export default Header;